export default "__VITE_ASSET__RVdq6Qbm__"